import React from "react";
import "./searchInput.css";
import Field from "../../field/field";
import SearchIcon from "../../svgs/icoMoon/icons/searchIconNew/searchIconNew";

const SearchInput = (props) => {
  const { onChange, placeholder, onClick, autoFocus, query, disabled } = props;
  return (
    <Field className="search">
      <div className="inputWithIcon">
        <input
          className="body_field"
          type="text"
          onChange={onChange}
          placeholder={placeholder ? placeholder : "keywords,etc"}
          onClick={onClick}
          autoFocus={autoFocus}
          value={query}
          disabled={disabled}
        />

        <SearchIcon />
      </div>
    </Field>
  );
};

export default SearchInput;
